import { apiRequest } from './client';
import { env } from '../config/env';

export function fetchOrders(token, params = {}) {
  const query = new URLSearchParams(params).toString();
  return apiRequest(`/admin/orders${query ? `?${query}` : ''}`, token);
}

export function fetchOrder(token, orderId) {
  return apiRequest(`/admin/orders/${orderId}`, token);
}

export function fetchUnshippedOrders(token, params = {}) {
  const query = new URLSearchParams(params).toString();
  return apiRequest(`/admin/orders/unshipped${query ? `?${query}` : ''}`, token);
}

export function syncOrders(token, options = {}) {
  return apiRequest('/admin/orders/sync', token, {
    method: 'POST',
    body: JSON.stringify(options),
  });
}

export function syncUnshippedToProcurement(token) {
  return apiRequest('/admin/orders/sync-unshipped-procurement', token, {
    method: 'POST',
    body: JSON.stringify({ unshippedOnly: true }),
  });
}

export function orderTrackingAction(token, orderId, action, payload = {}) {
  return apiRequest(`/admin/orders/${orderId}/tracking`, token, {
    method: 'POST',
    body: JSON.stringify({ action, ...payload }),
  });
}

export function updateI2iTracking(token, orderId, trackingNumber) {
  return apiRequest(`/admin/orders/${orderId}/i2i-tracking`, token, {
    method: 'PUT',
    body: JSON.stringify({ trackingNumber: trackingNumber || '' }),
  });
}

export function updateOrderSellable(token, orderId, { sellable, nonSellableReason }) {
  return apiRequest(`/admin/orders/${orderId}/sellable`, token, {
    method: 'PUT',
    body: JSON.stringify({
      sellable: Boolean(sellable),
      nonSellableReason: nonSellableReason || null,
    }),
  });
}

export function updateFulfillmentRemark(token, orderId, remark) {
  return apiRequest(`/admin/orders/${orderId}/fulfillment-remark`, token, {
    method: 'PUT',
    body: JSON.stringify({ remark: remark || '' }),
  });
}

export function markOrderDelivered(token, orderId) {
  return apiRequest(`/admin/orders/${orderId}/delivered`, token, {
    method: 'PUT',
    body: JSON.stringify({}),
  });
}

export function fetchShipmentOptions(token, marketplace = 'IN', options = {}) {
  const params = new URLSearchParams({ marketplace });
  if (options.amazonOrderId) {
    params.set('amazonOrderId', options.amazonOrderId);
  }
  return apiRequest(`/admin/orders/shipment-options?${params}`, token);
}

export async function downloadAmazonOrderDocument(token, orderId, documentType) {
  const response = await fetch(
    `${env.apiBaseUrl}/admin/orders/${orderId}/amazon-document?type=${encodeURIComponent(documentType)}`,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    }
  );

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.message || 'Unable to download Amazon document.');
  }

  const blob = await response.blob();
  const filename =
    response.headers.get('Content-Disposition')?.match(/filename="([^"]+)"/)?.[1] ||
    `amazon-${documentType}.pdf`;
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = filename;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(objectUrl);

  return { filename };
}
